import ArrowUpRight from 'images/icons/arrow-up-right.svg?svgr';
import Bell from 'images/icons/bell.svg?svgr';
import Branch from 'images/icons/branch.svg?svgr';
import Briefcase from 'images/icons/briefcase.svg?svgr';
import Chart from 'images/icons/chart.svg?svgr';
import ChartLine from 'images/icons/chart-line.svg?svgr';
import Checklist from 'images/icons/checklist.svg?svgr';
import Checkmark from 'images/icons/checkmark.svg?svgr';
import Checkmark2 from 'images/icons/checkmark-2.svg?svgr';
import ChevronDown from 'images/icons/chevron-down.svg?svgr';
import ChevronRight from 'images/icons/chevron-right.svg?svgr';
import ChevronUp from 'images/icons/chevron-up.svg?svgr';
import Clock from 'images/icons/clock.svg?svgr';
import Close from 'images/icons/close.svg?svgr';
import Close2 from 'images/icons/close-2.svg?svgr';
import Code from 'images/icons/code.svg?svgr';
import CodeBrackets from 'images/icons/code-brackets.svg?svgr';
import ExternalLink from 'images/icons/external-link.svg?svgr';
import Facebook from 'images/icons/facebook.svg?svgr';
import Graph from 'images/icons/graph.svg?svgr';
import Hamburger from 'images/icons/hamburger.svg?svgr';
import Health from 'images/icons/health.svg?svgr';
import Lightning from 'images/icons/lightning.svg?svgr';
import Linkedin from 'images/icons/linkedin.svg?svgr';
import Mail from 'images/icons/mail.svg?svgr';
import Merge from 'images/icons/merge.svg?svgr';
import Modules from 'images/icons/modules.svg?svgr';
import Monitoring from 'images/icons/monitoring.svg?svgr';
import No from 'images/icons/no.svg?svgr';
import Orbit from 'images/icons/orbit.svg?svgr';
import Pin from 'images/icons/pin.svg?svgr';
import Plane from 'images/icons/plane.svg?svgr';
import Planet from 'images/icons/planet.svg?svgr';
import Profile from 'images/icons/profile.svg?svgr';
import Rocket from 'images/icons/rocket.svg?svgr';
import Sleuth from 'images/icons/sleuth.svg?svgr';
import Ticket from 'images/icons/ticket.svg?svgr';
import Troubleshooting from 'images/icons/troubleshooting.svg?svgr';
import Truck from 'images/icons/truck.svg?svgr';
import Twitter from 'images/icons/twitter.svg?svgr';
import WarningSign from 'images/icons/warning-sign.svg?svgr';
import Wrench from 'images/icons/wrench.svg?svgr';
import Yes from 'images/icons/yes.svg?svgr';
import Youtube from 'images/icons/youtube.svg?svgr';

const icons = {
  'arrow-up-right': ArrowUpRight,
  'chart-line': ChartLine,
  'checkmark-2': Checkmark2,
  'chevron-down': ChevronDown,
  'chevron-right': ChevronRight,
  'chevron-up': ChevronUp,
  'close-2': Close2,
  'code-brackets': CodeBrackets,
  'external-link': ExternalLink,
  'warning-sign': WarningSign,
  bell: Bell,
  branch: Branch,
  briefcase: Briefcase,
  chart: Chart,
  checklist: Checklist,
  checkmark: Checkmark,
  clock: Clock,
  close: Close,
  code: Code,
  facebook: Facebook,
  graph: Graph,
  hamburger: Hamburger,
  health: Health,
  lightning: Lightning,
  linkedin: Linkedin,
  mail: Mail,
  merge: Merge,
  modules: Modules,
  monitoring: Monitoring,
  no: No,
  orbit: Orbit,
  pin: Pin,
  plane: Plane,
  planet: Planet,
  profile: Profile,
  rocket: Rocket,
  sleuth: Sleuth,
  ticket: Ticket,
  troubleshooting: Troubleshooting,
  truck: Truck,
  twitter: Twitter,
  wrench: Wrench,
  yes: Yes,
  youtube: Youtube,
};

export default icons;
